var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningFilledIcon = function SvgWarningFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5001 18.3337C5.89771 18.3337 2.16675 14.6027 2.16675 10.0003C2.16675 5.39795 5.89771 1.66699 10.5001 1.66699C15.1025 1.66699 18.8334 5.39795 18.8334 10.0003C18.8334 14.6027 15.1025 18.3337 10.5001 18.3337ZM9.66675 5.83366V10.8337H11.3334V5.83366H9.66675ZM10.5001 14.167C9.92478 14.167 9.45842 13.7006 9.45842 13.1253C9.45842 12.55 9.92478 12.0837 10.5001 12.0837C11.0754 12.0837 11.5417 12.55 11.5417 13.1253C11.5417 13.7006 11.0754 14.167 10.5001 14.167Z",
    fill: "#B21919"
  })));
};
export { SvgWarningFilledIcon as ReactComponent };
export default __webpack_public_path__ + "assets/de7e4700.svg";